import type { Config } from 'tailwindcss'
import defaultTheme from 'tailwindcss/defaultTheme'
import tailwindcssAnimate from 'tailwindcss-animate'

export default {
  // prefix: `tw-`,
  darkMode: [`class`],
  content: [`./src/**/*.{ts,tsx}`],
  safelist: [`hover:filter-none`],
  theme: {
    screens: {
      xs: `475px`,
      ...defaultTheme.screens
    },
    extend: {
      listStyleType: {
        square: `square`
      },
      backgroundImage: {
        'gradient-115': `linear-gradient(115deg, var(--tw-gradient-stops))`
      },
      colors: {
        'dvc-orange': `#F46737`,
        'dvc-purple': `#945DD5`,
        'dvc-teal': `#13ADC7`,
        'legacy-purple': {
          900: `#6B5090`,
          500: `#7B61FF`
        }
      },
      container: {
        center: true,
        screens: {
          sm: `640px`,
          md: `768px`,
          lg: `1024px`,
          xl: `1200px`
        },
        padding: {
          DEFAULT: `0.75rem`,
          md: `1rem`,
          xl: `2rem`
        }
      },
      fontFamily: {
        sans: [`Sora`, `Sora-fallback`, ...defaultTheme.fontFamily.sans]
      },
      keyframes: {
        'accordion-down': {
          from: { height: `0` },
          to: { height: `var(--radix-accordion-content-height)` }
        },
        'accordion-up': {
          from: { height: `var(--radix-accordion-content-height)` },
          to: { height: `0` }
        },
        slide: {
          '0%': { transform: `translate3d(0, 0, 0)` },
          '100%': { transform: `translate3d(-50.2%, 0, 0)` }
        },
        'bounce-horizontal': {
          '0%, 100%': {
            transform: `translateX(25%)`,
            'animation-timing-function': `cubic-bezier(0,0,0.2,1)`
          },
          '50%': {
            transform: `none`,
            'animation-timing-function': `cubic-bezier(0.8,0,1,1)`
          }
        },
        gradient: {
          to: {
            backgroundPosition: `var(--bg-size) 0`
          }
        }
      },
      animation: {
        'accordion-down': `accordion-down 0.2s ease-out`,
        'accordion-up': `accordion-up 0.2s ease-out`,
        slide: `slide 100s linear infinite`,
        'slide-fast': `slide 40s linear infinite`,
        'bounce-horizontal': `bounce-horizontal 1.5s infinite`,
        gradient: `gradient 8s linear infinite`
      },
      transitionDuration: {
        '1300': `1300ms`
      }
    }
  },
  plugins: [tailwindcssAnimate]
} satisfies Config
